import ArterHome from '@/views/livet/ArterHome'
import FactsHome from '@/views/livet/FactsHome'
import FactsEdit from '@/views/livet/FactsEdit'
import ArterList from '@/views/livet/ArterList'
import Art from '@/views/livet/Art'
import InfoGeneral from '@/views/livet/partials/InfoGeneral'
import InfoBase from '@/views/livet/partials/InfoBase'
import InfoEnvGeo from '@/views/livet/partials/InfoEnvGeo'
import InfoFacts from '@/views/livet/partials/InfoFacts'
import InfoLinks from '@/views/livet/partials/InfoLinks'
import InfoImages from '@/views/livet/partials/InfoImages'

import ArtLinkCreate from '@/views/livet/partials/ArtLinkCreate'
import ArtLinkEdit from '@/views/livet/partials/ArtLinkEdit'
import ArtCreate from '@/views/livet/ArtCreate'

export default [
  {
    path: 'livet/fakta',
      name: 'ArterFacts',
      component: FactsHome,
      children: [
        {
          path: 'ny',
          name: 'NewFact',
          component: FactsEdit,
        },
        {
          path: 'edit/:id',
          name: 'editFact',
          props: true,
          component: FactsEdit,
        },
      ]
  },
  {
  path: '/livet/arter',
  component: ArterHome,
  children: [
    {
      path: '',
      name: 'ArterList',
      component: ArterList,
      props: true,
      children: [
        {
          path: 'ny',
          name: 'ArtCreate',
          component: ArtCreate,
        },
      ]
    },
    
    {
      path: ':id',
      props: true,
      component: Art,
      children: [
        {
          path: 'allmant',
          name: 'art-info-general',
          props: true,
          component: InfoGeneral,
        },
        {
          path: 'arten',
          name: 'art-info-base',
          props: true,
          component: InfoBase,
        },
        {
          path: 'geo-och-miljo',
          name: 'art-info-geo-env',
          props: true,
          component: InfoEnvGeo,
        },
        {
          path: 'fakta',
          name: 'art-info-facts',
          props: true,
          component: InfoFacts,
        },
        {
          path: 'lankar',
          name: 'art-info-links',
          props: true,
          component: InfoLinks,
          children: [
            {
              path: 'ny',
              name: 'art-info-links-new',
              props: true,
              component: ArtLinkCreate,
            },
            {
              path: 'andra/:linkId',
              name: 'art-info-links-edit',
              props: true,
              component: ArtLinkEdit,
            },
          ],
        },
        {
          path: 'bilder',
          name: 'art-info-bilder',
          props: true,
          component: InfoImages,
        },
      ],
    },
  ],
}]
